import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { liveTrackinglayoutSelector } from '../features/layout/layoutSlice';
import { resetFindLatLng, setMapControl } from '../features/map/mapSlice';
import { removeZoneDetailView, removeMarkerDetailView } from '../features/places/placesSlice';

import PlacesTop from '../components/places/PlacesTop';

import ZonesListView from '../components/places/ZonesListView';
import MarkersListView from '../components/places/MarkersListView';
import ZoneCreateForm from '../components/places/ZoneCreateForm';
import MarkerCreareForm from '../components/places/MarkerCreateForm';
import PacesBarPaginate from '../components/places/PlacesBarPaginate';

const PlacesView = () => {
    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);

    const [listView, setListView] = useState('zoneList');
    //views - noList, zoneList, markerList, zoneCreate, markerCreate
    const setListViewCallback = (view) => {
        setListView(view);
    }

    useEffect(() => {
        dispatch(removeZoneDetailView());
        dispatch(removeMarkerDetailView());
        dispatch(resetFindLatLng());
    }, [dispatch]);

    useEffect(() => {
        dispatch(setMapControl(listView.indexOf('marker') !== -1 ? 'marker' : 'zone'));
    }, [dispatch, listView]);

    useEffect(() => {
        return () => {
            dispatch(setMapControl('asset'));
            dispatch(removeZoneDetailView());
            dispatch(removeMarkerDetailView());
            dispatch(resetFindLatLng());
        }
    }, [dispatch])

    return (
        <div style={dimentions.sidebar}>
            <div style={dimentions.placesTop}>
                <PlacesTop setListViewCallback={setListViewCallback} listView={listView} />
            </div>
            <div style={{ ...dimentions.placesListView, overflow: 'auto' }}>
                {listView === 'zoneList' && <ZonesListView setListViewCallback={setListViewCallback} />}
                {listView === 'markerList' && <MarkersListView setListViewCallback={setListViewCallback} />}
                {listView === 'zoneCreate' && <ZoneCreateForm setListViewCallback={setListViewCallback} />}
                {listView === 'markerCreate' && <MarkerCreareForm setListViewCallback={setListViewCallback} />}
            </div>
            {
                (listView === 'zoneList' || listView === 'markerList') &&
                <div style={dimentions.eventBarPaginate}>
                    <PacesBarPaginate listView={listView} />
                </div>
            }

        </div>
    );
}

export default PlacesView;
